import React from 'react'
import PropTypes from 'prop-types'

import { ConfirmationDialog } from 'components'

const UnsavedChangesDialog = ({ open, setOpen, onConfirm }) => (
  <ConfirmationDialog
    open={open}
    setOpen={setOpen}
    text="Há informações preenchidas que ainda não foram salvas. Ao mudar de etapa, essas alterações serão perdidas. Deseja continuar?"
    textButton="Continuar"
    textButtonCancel="Cancelar"
    actionAcceptButton={onConfirm}
  />
)

UnsavedChangesDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
}

export default UnsavedChangesDialog
